import React, { useState } from "react";
import { Container, Form, Row, Col } from "react-bootstrap";
import { ToastContainer } from "react-toastify";
import AppButton from "../../Components/MerchantButton";
import "./UnifiedFormStyles.css";

function P1DoorHangerDetailsPage({ navigation }) {
  const [details, setDetails] = useState({
    p1_door_hanger_details_description: "",
    door_hanger_location: "",
    door_hanger_brand: "",
    door_hanger_count: "",
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDetails((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validate = () => {
    const newErrors = {};
    newErrors.door_hanger_location = !details.door_hanger_location;
    newErrors.door_hanger_brand = !details.door_hanger_brand;
    newErrors.door_hanger_count = !details.door_hanger_count;
    setErrors(newErrors);
    return !Object.values(newErrors).some(Boolean);
  };

  const handleNext = () => {
    if (validate()) {
      // Navigate to P1 Door Sticker Merchandising (Section 39)
      console.log("Navigating from Section 38 to Section 39 (P1 Door Sticker Merchandising)");
      navigation.go('p1-door-sticker-merchandising');
    }
  };

  const handleBack = () => {
    navigation.previous();
  };

  return (
    <div className="form-bg">
      <Container>
        <ToastContainer />
        <Row className="justify-content-md-center">
          <Col md={10}>
            <div className="form-main-header">
              <h4 className="form-title">P1 DOOR HANGER DETAILS</h4>
              <p className="form-desc">Please fill in all required details below</p>
            </div>
            <div className="form-main">
              <div className="form-main-content">

              <Form>
                  {/* P1 door hanger location */}
                  <Form.Group className="mb-4">
                    <Form.Label className="form-label">
                      P1 door hanger location <span className="form-required">*</span>
                    </Form.Label>
                    <div className="form-radio-group">
                      {[
                        "glass door - eye level",
                        "glass door - not eye level",
                        "counter",
                        "glass window",
                        "others"
                      ].map((location) => (
                        <div key={location} className="form-radio-item">
                          <div className="form-radio-flex">
                            <Form.Check
                              type="radio"
                              label={location}
                              name="door_hanger_location"
                              value={location}
                              checked={details.door_hanger_location === location}
                              onChange={handleChange}
                              className="form-radio"
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                    {errors.door_hanger_location && (
                      <div className="form-error">Required</div>
                    )}
                  </Form.Group>

                  {/* P1 door hanger branding */}
                  <Form.Group className="mb-4">
                    <Form.Label className="form-label">
                      P1 door hanger branding <span className="form-required">*</span>
                    </Form.Label>
                    <div className="form-radio-group">
                      {[
                        { value: "3", label: "3" },
                        { value: "2", label: "2" },
                        { value: "1.5", label: "1.5" },
                        { value: "old design - green bird", label: "old design - green bird" },
                        { value: "custom", label: "custom" }
                      ].map((branding) => (
                        <div key={branding.value} className="form-radio-item">
                          <div className="form-radio-flex">
                            <Form.Check
                              type="radio"
                              label={branding.label}
                              name="door_hanger_brand"
                              value={branding.value}
                              checked={details.door_hanger_brand === branding.value}
                              onChange={handleChange}
                              className="form-radio"
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                    {errors.door_hanger_brand && (
                      <div className="form-error">Required</div>
                    )}
                  </Form.Group>

                  {/* P1 door hanger count */}
                  <Form.Group className="mb-4">
                    <Form.Label className="form-label">
                      P1 door hanger count <span className="form-required">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="door_hanger_count"
                      value={details.door_hanger_count || ''}
                      onChange={handleChange}
                      placeholder="Short answer text"
                      isInvalid={errors.door_hanger_count}
                      className="form-input"
                    />
                    {errors.door_hanger_count && (
                      <div className="form-error">
                        Required
                      </div>
                    )}
                  </Form.Group>

                <div className="form-nav-btns">
                  <AppButton
                    onClick={navigation.previous}
                    variant="back"
                    className="form-btn variant-secondary"
                  >
                    ← Back
                  </AppButton>
                  <AppButton
                    onClick={handleNext}
                    variant="next"
                    className="form-btn variant-primary"
                  >
                    Next → 
                  </AppButton>
                </div>
              </Form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default P1DoorHangerDetailsPage;
